import { reactive } from 'vue';
import { v4 } from 'uuid';

export class MenuEntry {
    title = null;

    route = null;

    additionalRoutes = [];

    children = [];

    parent = null;

    identifier;

    static create() {
        const entry = reactive(new this());
        entry.generateIdentifier();
        return entry;
    }

    generateIdentifier() {
        this.identifier = v4();
    }

    setTitle(title) {
        this.title = title;
        return this;
    }

    setRoute(route) {
        this.route = route;
        return this;
    }

    setAdditionalRoutes(additionalRoutes) {
        this.additionalRoutes = additionalRoutes;
        return this;
    }

    setChildren(children) {
        this.children = children;
        children.forEach((child) => {
            child.setParent(this);
        });
        return this;
    }

    setParent(parent) {
        this.parent = parent;
        return this;
    }
}
